import { Fragment, useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarUnidades, limpiarUnidades } from '../../../actions/configuracion';

import NuevaUnidadModal from './NuevaUnidad';
import EditarUnidadModal from './EditarUnidad';
import EliminarUnidadModal from './EliminarUnidad';

const Unidades = () => {
    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.configuracion?.unidades || { listado: [] });

    const [textoFiltro, setTextoFiltro] = useState('');
    const [modalNueva, setModalNueva] = useState(false);
    const [unidadEditar, setUnidadEditar] = useState(null);
    const [unidadEliminar, setUnidadEliminar] = useState(null);

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: true, nombre: 'Unidades', path: '/configuracion/unidades' }
        ]));
    }, [dispatch]);

    useEffect(() => {
        dispatch(buscarUnidades());

        return () => {
            dispatch(limpiarUnidades());
        };
    }, [dispatch]);

    const dataFiltrada = useMemo(() => {
        const q = (textoFiltro || '').trim().toLowerCase();
        if (!q) return listado || [];

        return (listado || []).filter(u => {
            const nombre = (u?.nombre || '').toLowerCase();
            const descripcion = (u?.descripcion || '').toLowerCase();
            return nombre.includes(q) || descripcion.includes(q);
        });
    }, [listado, textoFiltro]);

    const columns = useMemo(() => ([
        {
            name: 'Nombre',
            selector: row => row?.nombre || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 1
        },
        {
            name: 'Descripción',
            selector: row => row?.descripcion || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 2
        },
        {
            name: 'Opciones',
            width: '140px',
            cell: row => {
                return (
                    <div className="d-flex align-items-center gap-2">
                        <button
                            type="button"
                            className="btn btn-sm btn-link px-2"
                            title="Editar"
                            onClick={() => setUnidadEditar(row)}
                        >
                            <i className="fa fa-edit text-warning" />
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-link px-2"
                            title="Eliminar"
                            onClick={() => setUnidadEliminar(row)}
                        >
                            <i className="fas fa-trash text-danger" />
                        </button>
                    </div>
                );
            }
        }
    ]), []);

    const paginationOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos'
    };

    const onChangeFiltroTabla = (e) => {
        setTextoFiltro(e.target.value);
    };

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Unidades</h3>

                    <div className="d-flex justify-content-end mb-3">
                        <div className="d-flex align-items-center gap-2 w-100 justify-content-end">
                            <div style={{ minWidth: 280 }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar en la tabla..."
                                    value={textoFiltro}
                                    onChange={onChangeFiltroTabla}
                                />
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setModalNueva(true)}
                            >
                                <i className="feather icon-plus" /> Nueva unidad
                            </button>
                        </div>
                    </div>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={dataFiltrada || []}
                            pagination
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover
                            striped
                            responsive
                            persistTableHead
                        />
                    </div>
                </div>
            </div>

            <NuevaUnidadModal
                show={modalNueva}
                onHide={() => setModalNueva(false)}
                onSuccess={async () => {
                    setModalNueva(false);
                    await dispatch(buscarUnidades());
                }}
            />
            <EditarUnidadModal
                show={!!unidadEditar}
                unidad={unidadEditar}
                onHide={() => setUnidadEditar(null)}
                onSuccess={async () => {
                    setUnidadEditar(null);
                    await dispatch(buscarUnidades());
                }}
            />

            <EliminarUnidadModal
                show={!!unidadEliminar}
                unidad={unidadEliminar}
                onHide={() => setUnidadEliminar(null)}
                onSuccess={async () => {
                    setUnidadEliminar(null);
                    await dispatch(buscarUnidades());
                }}
            />

        </Fragment>
    );
};

export default Unidades;
